import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import classNames from 'classnames';
import { forwardRef, useMemo, useCallback } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import { optionStyle } from '../../select.vanilla.mjs';
import { isMatchedItem } from '../../utils/item.mjs';
import { useSelectSearchContext, useSelectContext, Collection } from '../context.mjs';

const Option = forwardRef(
  ({
    className,
    children,
    disabled = false,
    value,
    textValue,
    hidden: hiddenFromProps,
    ...props
  }, ref) => {
    const { searchValue } = useSelectSearchContext();
    const { inputFocused, onValueChange } = useSelectContext();
    const valueString = useMemo(() => value.toString(), [value]);
    const hidden = useMemo(() => {
      const hiddenFromContext = searchValue !== "" && !isMatchedItem({ textValue, value: value.toString() }, searchValue);
      return hiddenFromProps ?? hiddenFromContext;
    }, [hiddenFromProps, textValue, searchValue, value]);
    const handleSelect = useCallback(() => {
      onValueChange(value);
    }, [onValueChange, value]);
    return /* @__PURE__ */ jsx(
      Collection.ItemSlot,
      {
        value: valueString,
        textValue,
        disabled,
        scope: void 0,
        children: /* @__PURE__ */ jsx(
          Legacy_Dropdown.RadioItem,
          {
            ...props,
            className: classNames(optionStyle, className),
            ref,
            hidden,
            disabled,
            value: valueString,
            textValue,
            onSelect: composeEventHandlers(props.onSelect, handleSelect, {
              checkForDefaultPrevented: false
            }),
            onPointerMove: composeEventHandlers(props.onPointerMove, (e) => {
              if (inputFocused) {
                e.preventDefault();
              }
            }),
            onPointerLeave: composeEventHandlers(props.onPointerLeave, (e) => {
              if (inputFocused) {
                e.preventDefault();
              }
            }),
            role: "option",
            children
          }
        )
      }
    );
  }
);

export { Option };
//# sourceMappingURL=Option.mjs.map
